import { DUPLICATE_OFFSET_PT } from '../constants/duplicate-offset'

/** The canvas commands Duplicate is built from. */
export type DuplicateSelectionCommands = {
  isTextEditSessionActive: () => boolean
  copySelectionToClipboard: () => boolean
  pasteFromClipboard: (
    inPlace: boolean,
    canvasPoint?: { canvasX: number; canvasY: number } | null,
    offsetPt?: number
  ) => boolean
}

/**
 * Duplicate (Ctrl/Cmd+D, the context menus and Edit → Duplicate): the same copy-then-paste
 * pipeline Paste in Place uses, offset by `DUPLICATE_OFFSET_PT` so the copy is visibly a second
 * object instead of stacked exactly on the source. Objects only — mid text edit there is no object
 * to duplicate, so it does nothing. Returns whether anything was duplicated.
 */
export function duplicateSelection({
  isTextEditSessionActive,
  copySelectionToClipboard,
  pasteFromClipboard,
}: DuplicateSelectionCommands): boolean {
  if (isTextEditSessionActive()) return false
  if (!copySelectionToClipboard()) return false

  return pasteFromClipboard(true, null, DUPLICATE_OFFSET_PT)
}
